import React from 'react';
import { createRoot } from 'react-dom/client';
import Search from './App';

const elementContainer = document.querySelector<HTMLElement>('#search-root');

if (elementContainer) {
  const root = createRoot(elementContainer);
  root.render(<Search />);
} else {
  console.warn('Search root container not found in the DOM');
}
